import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useIsSudo } from "@/lib/admin-utils";
import { authClient } from "@/lib/auth-client";

export function AdminRoute({ children }: { children: ReactNode }) {
  const { data: session, isPending } = authClient.useSession();
  const isAppAdmin = useIsSudo();
  const navigate = useNavigate();

  useEffect(() => {
    if (!(isPending || session)) {
      // User not authenticated, redirect to sign in
      navigate("/auth/sign-in");
    } else if (!isPending && session && !isAppAdmin) {
      // User authenticated but not an App admin, redirect to home
      navigate("/");
    }
  }, [session, isPending, isAppAdmin, navigate]);

  if (isPending) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  // Only render children if user is authenticated as an App admin.
  if (session && isAppAdmin) {
    return <>{children}</>;
  }

  return null;
}
